import ApiConnection from "./ApiConnection";
import Endpoints from "./Endpoint/Endpoints";
import { AxiosInstance } from "axios";
import { EventDispatcher } from "../../core/event-dispatcher/EventDispatcher";
import ApiResponseStatus from "./ApiResponseStatus";
import extractApiConnectionResponseStatus from "./extractApiConnectionResponseStatus";
import MockAdapter from "axios-mock-adapter";
import ResponseCode from "./ResponseCode";
import NotificationDispatcher from "../../core/notification-dispatcher/NotificationDispatcher";
import { responseCodeToMessage } from "./responseCodeToMessage";

export default class ApiClient {
    public readonly files: Endpoints.Files.Endpoint;
    public readonly offers_Id: Endpoints.Offers_Id.Endpoint;
    public readonly offers_Id_Mediums: Endpoints.Offers_Id_Mediums.Endpoint;
    public readonly offers_Id_Availabilities: Endpoints.Offers_Id_Availabilities.Endpoint;
    public readonly offers_Id_FilterOptions: Endpoints.Offers_Id_FilterOptions.Endpoint;
    public readonly sessions: Endpoints.Sessions.Endpoint;
    public readonly mediumAvailabilities_Id: Endpoints.MediumAvailabilities_Id.Endpoint;
    public readonly mediumAvailabilities: Endpoints.MediumAvailabilities.Endpoint;

    constructor(connection: ApiConnection, notificationDispatcher: NotificationDispatcher) {
        configureApiResponseHandler(connection, notificationDispatcher);
        _mockUnimplementedEndpoints(connection);
        this.files = new Endpoints.Files.Endpoint(connection);
        this.offers_Id = new Endpoints.Offers_Id.Endpoint(connection);
        this.offers_Id_Mediums = new Endpoints.Offers_Id_Mediums.Endpoint(connection);
        this.offers_Id_Availabilities = new Endpoints.Offers_Id_Availabilities.Endpoint(connection);
        this.sessions = new Endpoints.Sessions.Endpoint(connection);
        this.mediumAvailabilities_Id = new Endpoints.MediumAvailabilities_Id.Endpoint(connection);
        this.mediumAvailabilities = new Endpoints.MediumAvailabilities.Endpoint(connection);
        this.offers_Id_FilterOptions = new Endpoints.Offers_Id_FilterOptions.Endpoint(connection);
    }
}

const configureApiResponseHandler = (axios: AxiosInstance, notificationDispatcher: NotificationDispatcher): void => {
    axios
        .interceptors
        .response
        .use(
            response => {
                return response;
            },

            error => {
                const responseStatus: ApiResponseStatus = extractApiConnectionResponseStatus(error);

                if (responseStatus.code === ResponseCode.REQUEST_CANCELED) {
                    return Promise.reject(null);
                }

                notificationDispatcher.dispatchError(responseCodeToMessage(responseStatus.code))

                return Promise.reject(error);
            }
        );
}


const _mockUnimplementedEndpoints = (connection: ApiConnection): void => {
    const mock = new MockAdapter(connection, { onNoMatch: 'passthrough' });

    // mock.onGet(/\/offers\/\w+\/mediums/).reply(200, {
    //     records: [
    //         createOfferMediumStub(),
    //         createOfferMediumStub(),
    //         createOfferMediumStub(),
    //         createOfferMediumStub(),
    //         createOfferMediumStub(),
    //     ],
    // });

}